export default __webpack_public_path__ + "fonts/master-card.svg";